// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_FetchDeviceTokenInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/devices_franquias/fetch_device_token
 *
 * Fetches the device token from Evolution API and saves it to the database.
 */
import { registerContract } from './validate'

export interface DevicesFranquias_FetchDeviceTokenInput {
device_id: number
instance_name: string
}

registerContract('DevicesFranquias_FetchDeviceTokenInput', {
  device_id:     { type: 'number',  required: true },
  instance_name: { type: 'string',  required: true },
})
